import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_3 = {
  key: 1,
  class: "mt-4"
}

import {computed, ref, VNodeRef, watch} from 'vue';
import ErrorComp from '@/components/Error.vue';
import {useStorage} from '@/composables/storage';
import router from '@/router';
import {doAlert} from '@/util';
import DatePicker from '@/components/DatePicker.vue';
import {postProviderDocuments} from '@/api/module/provider';
import useDetailContacts from '@/store/detailContact';
import {storeToRefs} from 'pinia';
import {useRoute} from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerDocumentCreate',
  setup(__props) {

const route = useRoute();

const kundenNr = parseInt(route.params.id as string);

const detailContactStore = useDetailContacts();
useStorage(
    detailContactStore,
    () => {
      return 'Dokument hochladen';
    },
    (route) => {
      return {
        KundenNr: kundenNr,
        AnsprechpartnerNr: parseInt(route.params.contact_id as string),
      };
    },
);
const {error, loading} = storeToRefs(detailContactStore);

const loadingSave = ref(false);
const Bezeichnung = ref('');
const GueltigVon = ref('');
const GueltigBis = ref('');
const file = ref(null as File[] | null);
const formValid = ref(false);
const form = ref(null as (Element & VNodeRef & { validate(): boolean }) | null);

watch(form, (form) => form?.validate());

const uploadUrl = computed(() => {
  return `https://api.service-erp.de/service/kunde/api/v1/Kunde/${kundenNr}/action/datei/hochladen`;
});

const uploadFile = computed({
  get(): File[] | null {
    return file.value;
  },
  set(val: File[] | null) {
    if (!val) {
      file.value = null;
      return;
    }

    file.value = val;

    if (Bezeichnung.value == '') {
      if (file.value[0].name.includes('.')) {
        Bezeichnung.value = file.value[0].name.split('.').slice(0, -1).join('');
      } else {
        Bezeichnung.value = file.value[0].name;
      }
    }
  },
});
const gueltigVon = computed({
  get(): string {
    return GueltigVon.value ?? '';
  },
  set(newDate: string | undefined) {
    if (!newDate) {
      GueltigVon.value = '';
      return;
    }
    GueltigVon.value = newDate;
  },
});
const gueltigBis = computed({
  get(): string {
    return GueltigBis.value ?? '';
  },
  set(newDate: string | undefined) {
    if (!newDate) {
      GueltigBis.value = '';
      return;
    }
    GueltigBis.value = newDate;
  },
});

async function save() {
  try {
    loadingSave.value = true;
    form.value?.validate();
    if (!formValid.value) {
      throw new Error('Bitte alle Felder korrekt ausfüllen');
    }
    const formData = new FormData();
    formData.append('GueltigBis', GueltigBis.value!);
    formData.append('GueltigVon', GueltigVon.value!);
    formData.append('Bezeichnung', Bezeichnung.value!);
    formData.append('Datei', file.value![0] as File);
    await postProviderDocuments(parseInt(route.params.id as string), formData);
    router.back();
  } catch (err: any) {
    await doAlert(err.message, 'Fehler');
  } finally {
    loadingSave.value = false;
  }
}
function ruleRequired(val: string | null | undefined): string | true {
  if (!val) return 'erforderlich';

  return true;
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_unref(loading) && !_unref(error))
      ? (_openBlock(), _createBlock(_component_v_container, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_form, {
              modelValue: formValid.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formValid).value = $event)),
              ref: form.value,
              submit: uploadUrl.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: Bezeichnung.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((Bezeichnung).value = $event)),
                  label: "Bezeichnung",
                  name: "Bezeichnung",
                  rules: [ruleRequired]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_file_input, {
                  modelValue: uploadFile.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((uploadFile).value = $event)),
                  label: "Datei",
                  name: "File",
                  rules: [ruleRequired]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(DatePicker, {
                  class: "mt-5",
                  modelValue: gueltigVon.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((gueltigVon).value = $event)),
                  label: "Gültig Von",
                  name: "GueltigVon"
                }, null, 8, ["modelValue"]),
                _createVNode(DatePicker, {
                  class: "mt-5",
                  modelValue: gueltigBis.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((gueltigBis).value = $event)),
                  label: "Gültig Bis",
                  name: "GueltigBis"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: save,
                  disabled: !formValid.value,
                  loading: loadingSave.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Speichern")
                  ], undefined, true),
                  _: 1
                }, 8, ["disabled", "loading"])
              ], undefined, true),
              _: 1
            }, 8, ["modelValue", "submit"])
          ], undefined, true),
          _: 1
        }))
      : (_unref(error))
        ? (_openBlock(), _createBlock(ErrorComp, {
            key: 1,
            module: _ctx.dataStorageModule
          }, null, 8, ["module"]))
        : _createCommentVNode("", true),
    _createVNode(_component_v_overlay, {
      "model-value": loadingSave.value || _unref(loading),
      class: "align-center justify-center",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, { class: "text-center" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_v_progress_circular, { indeterminate: "" })
                ]),
                (_unref(loading))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Dokument­anlegung wird geladen"))
                  : _createCommentVNode("", true),
                (loadingSave.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Dokument wird gespeichert"))
                  : _createCommentVNode("", true)
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        })
      ], undefined, true),
      _: 1
    }, 8, ["model-value"])
  ]))
}
}

})